module.exports = __webpack_public_path__ + "static/media/wrongpass-page-login.71190cb2.png";